import { ChargingSchedule, WeekDay } from 'src/Libs/flow/installation/forms'

/** Given the schedules of a ${evseType} device, it returns a map of each weekday to the index of the schedule where it is active. */
export const getWeekdayIndexes = (schedules: ChargingSchedule): Record<WeekDay, number | null> => {
  const weekdays: Record<WeekDay, number | null> = {
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null,
  }

  for (let index = 0; index < schedules.length; index++) {
    for (const [day, value] of Object.entries(schedules[index].weekDays)) {
      if (value) weekdays[day as WeekDay] = index
    }
  }

  return weekdays
}

/** An array of the weekdays as a helper for the weekday-selector */
export const commonWeekdays: { index: number; translationKey: string; nameKey: WeekDay }[] = [
  {
    index: 0,
    translationKey: 'common.mondayShort',
    nameKey: 'monday',
  },
  {
    index: 1,
    translationKey: 'common.tuesdayShort',
    nameKey: 'tuesday',
  },
  {
    index: 2,
    translationKey: 'common.wednesdayShort',
    nameKey: 'wednesday',
  },
  {
    index: 3,
    translationKey: 'common.thursdayShort',
    nameKey: 'thursday',
  },
  {
    index: 4,
    translationKey: 'common.fridayShort',
    nameKey: 'friday',
  },
  {
    index: 5,
    translationKey: 'common.saturdayShort',
    nameKey: 'saturday',
  },
  {
    index: 6,
    translationKey: 'common.sundayShort',
    nameKey: 'sunday',
  },
]
